// extracted by mini-css-extract-plugin
export default {"label":"ci2_label__DHhI8","c":"ci2_c__9r-BG","trail":"ci2_trail__ZqB-2"};